const backendUrl = "https://admin.dvxtraining.com";
// const backendUrl = "http://127.0.0.1:8000";
const normalizedBackendUrl = backendUrl.replace(/\/$/, "");
// console.log(normalizedBackendUrl,55555)
const BASE_URL = `${normalizedBackendUrl}/api`;

export default BASE_URL;
